import styled from "styled-components";
import { ChangeEvent, useEffect, useState } from "react";
import * as CommonTypes from '../../../types/common.types'
import { countries } from "countries-list";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useGlobal } from "../../../context/global";
import { useAlly } from "../../../context/ally";
import AllyService from "../../../services/ally.service";
import m from "../../../styles/molanturTheme";
import { Avatar, Badge, Card, Dialog, Field } from "../ui";

const countryName = (code: string) => (countries as Record<string, { name: string }>)[code]?.name || code

// Todos los pasajeros que cargó el aliado. Solo datos que le sirven a él: sin ids de la base ni
// datos del vendedor.
export default function Passengers() {
    const { setIsLoading } = useGlobal()
    const {setIsPassengersModalOpen} = useAlly()
    const [initialList, setInitialList] = useState<CommonTypes.Passenger[]>([])
    const [list, setList] = useState<CommonTypes.Passenger[]>(initialList)
    useEffect(() => {
        async function retrieveList () {
            setIsLoading(true)
            try {
                const response = await AllyService.listPassengers()
                setInitialList(response.data)
                setList(response.data)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        retrieveList()
    }, [])

    function onChangeValue(e: ChangeEvent<HTMLInputElement>) {
        const search = e.target.value.toLowerCase()
        const newList = initialList.filter((item) => (item.email || '').toLowerCase().includes(search) || (item.name || '').toLowerCase().includes(search))
        setList(newList)
    }
    return (
        <Dialog title="Mis pasajeros" wide onClose={() => setIsPassengersModalOpen(false)}>
            <Field label="Buscar pasajero" hideLabel icon="search" type="search" placeholder="Buscar por nombre o email" autoComplete="off"
                onChange={onChangeValue} />
            <List>
                {
                    list.map((passenger, idx) => (
                        <Card key={idx} $pad={14}>
                            <div className="head">
                                <Avatar name={passenger.name || ''} size={38} />
                                <div>
                                    <strong>{passenger.name}</strong>
                                    <span>{countryName(passenger.nationality)}{passenger.age ? ` · ${passenger.age} años` : ''}</span>
                                </div>
                                {passenger.admin_id && <Badge>Cargado por la agencia</Badge>}
                            </div>
                            <dl>
                                <div><dt>Email</dt><dd>{passenger.email}</dd></div>
                                {passenger.phone && <div><dt>Teléfono</dt><dd>{passenger.phone}</dd></div>}
                                {passenger.hotel && <div><dt>Hotel</dt><dd>{passenger.hotel}</dd></div>}
                                {passenger.rut_passport && <div><dt>RUT / Pasaporte</dt><dd>{passenger.rut_passport}</dd></div>}
                                {passenger.remark && <div><dt>Remarks</dt><dd>{passenger.remark}</dd></div>}
                            </dl>
                            <div className="date">Cargado el {format(new Date(passenger.created_at), "d 'de' MMM yyyy", { locale: es })}</div>
                        </Card>
                    ))
                }
                {list.length === 0 && <p className="empty">No hay pasajeros que mostrar.</p>}
            </List>
        </Dialog>
    )
}

const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    .head {
        display: flex;
        align-items: center;
        gap: 10px;
        > div {
            flex: 1;
            min-width: 0;
        }
        strong {
            display: block;
            font-weight: 600;
        }
        span {
            font-size: 12.5px;
            color: ${m.color.inkFaint};
        }
    }
    dl {
        margin: 10px 0 0;
        > div {
            display: flex;
            justify-content: space-between;
            gap: 14px;
            padding: 6px 0;
            border-top: 1px solid ${m.color.line};
        }
    }
    dt {
        flex-shrink: 0;
        font-size: 13px;
        color: ${m.color.inkSoft};
    }
    dd {
        margin: 0;
        min-width: 0;
        text-align: right;
        font-size: 13px;
        font-weight: 600;
        overflow-wrap: anywhere;
    }
    .date {
        margin-top: 6px;
        font-size: 11.5px;
        color: ${m.color.inkFaint};
    }
    .empty {
        margin: 20px 0;
        text-align: center;
        font-size: 13.5px;
        color: ${m.color.inkFaint};
    }
`
